import { render, staticRenderFns } from "./company-user-list.vue?vue&type=template&id=0dd31f3d"
import script from "./company-user-list.ts?vue&type=script&lang=js&external"
export * from "./company-user-list.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports